<script setup lang="ts">
import { useProductParams } from '@/composables/useProductParams';
const { id } = useProductParams();
const { data: category, fetchCategory } = useCategory();
await fetchCategory();

useSeoMeta({
  title: category.value?.meta_title,
  description: category.value?.meta_description,
  ogTitle: category.value?.meta_title,
  ogDescription: category.value?.meta_description,
  ogImage: category.value?.images?.medium?.url,
});

useHead({
  link: [
    ...Object.keys(category.value?.alternative_urls)
      .map((lang) => {
        return {
          rel: 'alternate',
          hreflang: lang,
          href: category.value?.alternative_urls[lang],
        };
      }),
  ],
});
</script>

<template>
  <VContainer>
    <VProductListing 
      :categoryId="id" 
      :title="category?.name" 
      :short_description="category?.description"
      :category="category"
    />
  </VContainer>
</template>
